import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useHistory } from "react-router-dom";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from '../../../utilities/TableUtil';
import { normalColumn, dateColumn, actionEditColumn, statusColumn } from '../../../components/DataTable/DataTable.js';
import * as bodyStyle from '../../../components/DataTable/ConsBodyStyle.js';


export default function P411ListA({ dataTable, onRowClick }) {

    const history = useHistory();
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    // const [globalFilter, setGlobalFilter] = useState(null);
    const actionBodyEdit = (data) => {
        history.push({
            pathname: '412',
            state: { contractNo: data.contractNo },
        });
    };
    
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows} 
                    onPage={(e)=>onPageChange(e,setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    onRowClick={onRowClick}
                    selectionMode="single"
                >

                    <Column sortable field="contractSeq" header="ลำดับที่" body={(e) => normalColumn(e, 'contractSeq', 'ลำดับที่')} style={{textAlign: 'center',width: '8%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="contractNo" header="เลขที่สัญญา" body={(e) => normalColumn(e, 'contractNo', 'เลขที่สัญญา')} style={{textAlign: 'center',width: '10%' }} bodyStyle={bodyStyle.TXT_LEFT} />
                    <Column field="contractRoute" header="จำนวนเส้นทาง" body={(e) => normalColumn(e, 'contractRoute', 'จำนวนเส้นทาง')} style={{ textAlign: 'center',width: '10%'}}  bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="contractPeriod" header="ระยะเวลาโครงการ"  body={(e) => normalColumn(e, 'contractPeriod', 'ระยะเวลาโครงการ')} style={{ textAlign: 'center',width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column field="totalPipeLength" header="ความยาวรวม (เมตร)"  body={(e) => normalColumn(e, 'totalPipeLength', 'ความยาวรวม(เมตร)')} style={{ textAlign: 'center', width: '10%' }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="contractor" header="บริษัทรับเหมา"  body={(e) => normalColumn(e, 'contractor', 'บริษัทรับเหมา')} style={{ textAlign: 'center' }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="inspectContractCount" header="จำนวนงานที่ตรวจ (ครั้ง)"  body={(e) => normalColumn(e, 'inspectContractCount', 'จำนวนงานที่ตรวจ(ครั้ง)')} style={{ textAlign: 'center', width: '10%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="inspectContractMobileCount" header="ผ่าน Mobile App (ครั้ง)"  body={(e) => normalColumn(e, 'inspectContractMobileCount', 'ผ่านMobile App(ครั้ง)')} style={{ textAlign: 'center', width: '10%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                
                </DataTable>
            </div>
        </div>
    )
}
